<ifc-app-scroll-container [widgetsWithTopHeader]="true"
                          ngClass="layout ">

  <div class="layout margin flex-std"
       [@routerTransition]="'fly'">

    <ifb-panel>
      <ng-container *ngIf="customerInfoData; else noData">
        <ifb-card>
          <ifb-customer-info-widget [data]="customerInfoData"
                                    [edit]="canEditCustomerInfo">
          </ifb-customer-info-widget>
        </ifb-card>
        <ifb-card>
          <ifb-customer-other-info-widget [data]="customerInfoData"
                                          [edit]="canEditCustomerInfo">
          </ifb-customer-other-info-widget>
          <ifb-customer-loans-widget [edit]="canEditCustomerInfo"
                                     [customerId]="customerInfoData?.id"
                                     [salesforceViewMode]="salesforceViewMode">
          </ifb-customer-loans-widget>
          <ifb-customer-identity-verification-widget *ngIf="canReadCustomerIdentity"
                                                     [identityVerification]="customerInfoData?.identityVerification"
                                                     [customerId]="customerInfoData.id"
                                                     [customerStatus]="customerInfoData?.status"
                                                     [canEditManually]="canEditCustomerIdentity"
                                                     [canUseActionLinks]="canUseIdentityActions"
                                                     (refreshCustomerData)="refreshCustomerData()">
          </ifb-customer-identity-verification-widget>
          <ifb-customer-identity-verification-activity-widget *ngIf="canReadCustomerIdentity"
                                                     [customerId]="customerInfoData.id"
                                                     [kbaData]="customerInfoData?.kba"
                                                     [idVerseAttempts]="customerInfoData?.idVerseAttempts"
                                                     [canInvalidate]="canUseIdentityActions"
                                                     (refreshCustomerData)="refreshCustomerData()">
          </ifb-customer-identity-verification-activity-widget>
        </ifb-card>
      </ng-container>
      <ng-template #noData>No customer data</ng-template>
    </ifb-panel>
  </div>
</ifc-app-scroll-container>
